"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDynamics = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const baseLibrary_1 = require("../baseLibrary");
class MbAppDynamics extends baseLibrary_1.BaseLibrary {
    async load() {
        if (window.APPDYNAMICS_APP_KEY && window.APPDYNAMICS_APP_KEY.trim()) {
            this.instance = new web_ui_framework_1.AppDynamics(window.APPDYNAMICS_APP_KEY);
            await this.instance.load();
        }
        else {
            web_ui_framework_1.Log.warn('AppDynamics: There is no valid APPDYNAMICS_APP_KEY configured');
        }
    }
}
const AppDynamics = new MbAppDynamics();
exports.AppDynamics = AppDynamics;
//# sourceMappingURL=index.js.map